import { gql } from "@apollo/client";

export const listEngagements = gql`
  query ListEngagements($filter: EngagementFilter!) {
    listEngagements(filter: $filter) {
      total
      items {
        id
        profileId
        performanceDate
        campaignId
        campaignName
        profileEmail
        profilePhone
        profileLogin
        engagementType
        deviceId
        identifier
        productSkus
        programPoints
        campaignPoints
        status
        image
        channel
        vendorName
        channel
        productBrand
        campaignShortName
        campaignType
        campaignStatus
        fulfillmentStatus
        outcomes {
          outcome
          value
          consumerReward {
            name
          }
        }
        failureReasons {
          code
          message
          ruleSlug
          metadata {
            ruleFunction
            ruleData
            ruleLogic
            ruleCategory
          }
        }
      }
    }
  }
`;

export const listEngagementsShort = gql`
  query ListEngagements($filter: EngagementFilter!) {
    listEngagements(filter: $filter) {
      total
      items {
        id
        profileId
        performanceDate
        campaignId
        campaignName
        profileEmail
        profilePhone
        engagementType
        identifier
        programPoints
        campaignPoints
        status
      }
    }
  }
`;
